<template>
  <button
    class="app__button button"
    :data-type="data.type"
    @click="handlerClick"
  >
    <svg x="0px" y="0px" viewBox="0 0 100 88" v-if="data.type === 'boolean'">
      <path
        d="M77,15c-17.1-7.4-39.8-6.1-56.3,1.7c-8.4,4-15.8,9.8-18.5,17.1c-1.6,4.3-1.6,8.8-0.4,13.1
        c1.6,17.3,22.2,31,47.3,31c4.6,0.2,9-0.3,13.2-1.3c8.7-1.8,16.3-5.2,22.2-9.8c7.5-4.9,
        12.8-11.2,14.2-18.7C101,35.2,92.3,21.6,77,15z"
      />
    </svg>

    <svg x="0px" y="0px" viewBox="0 0 100 100" v-else>
      <path
        class="svg__outline"
        d="M98.6,44.3c-1-7.5-4.1-14.2-8.7-19.8C82.3,13.2,69.4,5.4,54.5,4c-2-0.2-4.1-0.3-6.1-0.2c0,
        0,0,0,0,0C24.6,4.4,5.1,21.5,2.4,43.4c-1.7,6.7-2,13.8-0.2,20.5c2.7,10,10.1,17.9,18.5,
        23.4C37.2,97.9,59.9,99.7,77,89.6C92.3,80.6,101,61.9,98.6,44.3z M52.5,3.8c-0.2,0-0.4,
        0-0.6,0c0,0,0.1,0,0.1,0C52.2,3.8,52.4,3.8,52.5,3.8z"
      />
      <path
        v-if="data.type === 'list'"
        class="svg__fill"
        d="M98.6,44.3c-1-7.5-4.1-14.2-8.7-19.8C82.3,13.2,69.4,5.4,54.5,4c-2-0.2-4.1-0.3-6.1-0.2c0,
        0,0,0,0,0C24.6,4.4,5.1,21.5,2.4,43.4c-1.7,6.7-2,13.8-0.2,20.5c2.7,10,10.1,17.9,18.5,
        23.4C37.2,97.9,59.9,99.7,77,89.6C92.3,80.6,101,61.9,98.6,44.3z M52.5,3.8c-0.2,0-0.4,
        0-0.6,0c0,0,0.1,0,0.1,0C52.2,3.8,52.4,3.8,52.5,3.8z"
      />
    </svg>
    <span v-if="data.content">{{ data.content }}</span>
  </button>
</template>

<script>
import { mapState } from 'vuex';
import audio from '@/scripts/audio';

export default {
  name: 'GameButton',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      game: 'currentGame',
    }),
  },

  methods: {
    handlerClick() {
      this.$store.dispatch('checkAnswer', parseInt(this.data.value, 10));
      this.$eventHub.$emit('count-down-stop');
      audio.play('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  position: relative;

  display: flex;
  align-items: center;

  svg {
    overflow: visible;

    path {
      transform-origin: 50% 50%;
      transition: transform .6s ease;
    }
  }

  &:hover {
    svg path {
      transform: scale(1.2);
    }
  }

  &[data-type="button"] {
    width: calc(var(--unit-vw) * 1.8);
    flex: 0 0 calc(var(--unit-vw) * 1.8);
    height: calc(var(--unit-vw) * 1.8);
    justify-content: center;

    svg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }

    @extend %font-size-s;

    @include mq(ipadP) {
      width: calc(var(--unit-vw) * 2.2);
      flex: 0 0 calc(var(--unit-vw) * 2.2);
      height: calc(var(--unit-vw) * 2.2);
    }
  }

  &[data-type="boolean"] {
    min-width: calc(var(--unit-vw) * 2);
    min-height: calc(var(--unit-vw) * 2);
    justify-content: center;
    padding: 30px;

    svg {
      position: absolute;
      width: 100%;
      margin: auto;
    }

    @extend %font-size-s;

    @include mq(ipadP) {
      width: calc(var(--unit-vw) * 2);
      height: calc(var(--unit-vw) * 2);
      padding: unset;
    }
  }

  &[data-type="list"] {
    justify-content: flex-start;

    @extend %font-size-s;

    svg {
      position: relative;
      flex: 0 0 calc(var(--unit-vw) * 0.5);
      width: calc(var(--unit-vw) * 0.5);
      margin: 0 calc(var(--unit-vw) * 0.25) 0 calc(var(--unit-vw) * 0.25);

      overflow: visible;
    }

    .svg__outline,
    .svg__fill {
      display: block;
      transform-origin: center;
      transition: transform 0.8s cubic-bezier(.5,0,0,1);
    }
    .svg__outline {
      fill: none;
      stroke-width: 3px;
    }
    .svg__fill {
      transform: scale(0);
    }

    span {
      text-align: left;
    }

    &:hover svg {
      .svg__fill {
        transform: scale(1);
      }
      .svg__outline {
        transform: scale(0);
      }
    }

    @include mq(ipadP) {
      margin: 0 calc(var(--unit-vw) * 0.2) 0 calc(var(--unit-vw) * 0.1);
    }
  }

  span {
    position: relative;
  }
}
</style>
